import { ToastActionEnum } from '@shared-lib/services/toast.service';

export const TOAST_MESSAGE = {
  // FIXME: move to apiErrorCodeMap
  LOGIN: {
    error_initialize: 'Failed to initialize login with provider',
    error_invalid_provider: 'Invalid SSO provider',
    error_sso_general:
      "We couldn't complete the sign-in with your identity provider. This can sometimes be a temporary issue. Please try again, or contact support if the problem continues.",
  },

  ERROR: {
    unauthorized: 'You are unauthorized. Please log in to continue',
    general: 'Something went wrong',
    getting_data: 'Error occurred in process of getting data',
    uploading_file: 'File failed to upload',
    processing_files: 'Files failed to process',
    accessing_client_portal: 'Failed to access Client Portal',
    resuming_mortgage: 'Mortgage failed to resume',
    exporting_referral_codes: 'Referral codes fail to export',
    revoking_session: 'Session failed to revoke',
    revoking_sessions: 'Sessions failed to revoke',

    [ToastActionEnum.ActionCreate]: (entityName: string): string => `${entityName} failed to create`,
    [ToastActionEnum.ActionUpdate]: (entityName: string): string => `${entityName} failed to update`,
    [ToastActionEnum.ActionDelete]: (entityName: string): string => `${entityName} failed to delete`,
    [ToastActionEnum.ActionActivate]: (entityName: string): string => `${entityName} failed to activate`,
    [ToastActionEnum.ActionDeactivate]: (entityName: string): string => `${entityName} failed to deactivate`,
    [ToastActionEnum.ActionReassign]: (entityName: string): string => `${entityName} failed to start reassign process`,
    [ToastActionEnum.ActionClose]: (entityName: string): string => `${entityName} failed to close`,
    [ToastActionEnum.ActionCopy]: (entityName: string): string => `We were unable to copy the ${entityName} to your clipboard`,
    [ToastActionEnum.ActionEmail]: (entityName: string): string => `We were unable to send the ${entityName} email notification.`,
  },
  SUCCESS: {
    resuming_mortgage: 'Mortgage resumed successfully!',
    adding_document: 'Document added successfully!',

    [ToastActionEnum.ActionCreate]: (entityName: string): string => `${entityName} created successfully!`,
    [ToastActionEnum.ActionUpdate]: (entityName: string): string => `${entityName} updated successfully!`,
    [ToastActionEnum.ActionDelete]: (entityName: string): string => `${entityName} deleted successfully!`,
    [ToastActionEnum.ActionActivate]: (entityName: string): string => `${entityName} activated successfully!`,
    [ToastActionEnum.ActionDeactivate]: (entityName: string): string => `${entityName} deactivated successfully!`,
    [ToastActionEnum.ActionReassign]: (entityName: string): string => `${entityName} reassign started!`,
    [ToastActionEnum.ActionClose]: (entityName: string): string => `${entityName} closed successfully!`,
    [ToastActionEnum.ActionCopy]: (entityName: string): string => `${entityName} copied to your clipboard`,
    [ToastActionEnum.ActionEmail]: (entityName: string): string => `${entityName} email notification has been sent successfully!`,
  },
  INFO: {
    email_data_link: 'We will send you a link to the data via email as soon as it is ready.',
    processing_files_started: 'Processing of the files has started',
    hr_emails_sent: 'Home report mails have been sent.',
    hr_emails_sending_enabled: 'Sending home report emails is enabled.',
    hr_emails_sending_disabled: 'Sending home report emails is disabled.',
  },
  WARNING: {
    mortgage_doc_ai_in_progress: 'A MortgageDocAI Batch is currently being processed.',
  },
};
